import { isAddress } from 'web3-utils'
import namehash from '@ensdomains/eth-ens-namehash'
import { validate } from '@ensdomains/ens-validation'

import { apiEndpoint } from './config'

const Web3Eth = require('web3-eth') // FIXME: using import statement breaks typescript

const eth = new Web3Eth(apiEndpoint)

type ENSResolver = (value: string) => Promise<string>

export const lookup: ENSResolver = (ensName) => new Promise(async (resolve, reject) => {
  if (!isENSDomain(ensName)) {
    reject(`${ensName} was provided where a valid ENS name was expected`)
    return
  }

  try {
    const ethAddress = await eth.ens.getAddress(ensName)
    resolve(ethAddress)
  } catch (ex) {
    reject(ex)
  }
})

/**
 * Basically a copy-paste of https://github.com/web3/web3.js/issues/2683#issuecomment-1005900701
 */
export const reverseLookup: ENSResolver = (ethAddress) => new Promise(async (resolve, reject) => {
  if (!isAddress(ethAddress)) {
    reject(`${ethAddress} was provided where an Ethereum address was expected`)
    return
  }

  try {
    const lookup = ethAddress.toLowerCase().slice(2) + '.addr.reverse'
    const resolver = await eth.ens.getResolver(lookup)
    const nh = namehash.hash(lookup)
    const ensName = await resolver.methods.name(nh).call();

    if (ensName && ensName.length > 0) {
      // FIXME: double-check if it's not an impostor?
      resolve(ensName)
    } else {
      resolve('')
    }
  } catch(e) {
    console.error(e)
    // FIXME: Don't know what to do with this case yet -- not sure how to differentiate between a record not being found and other errors.
    resolve('')
  }
})

export const isENSDomain = (value?: string): boolean => {
  return typeof value === 'string' && value.endsWith('.eth') && validate(value)
}
